import React from "react";
import { RotatingLines } from "react-loader-spinner";

const DashboardLoader = () => {
  return (
    <div className="flex items-center justify-center py-10">
      <RotatingLines height={50} width={50} strokeColor="#6366f1" />
    </div>
  );
};

export default DashboardLoader;
